<template>
        <div class="col-md-4 homeitem  mt-4 pl-4 pr-4">
            <a :href="link">
            <b-card no-body class="mb-2 full" v-if="!blank">
                <b-card-body style="text-align:center;">
                    <img v-bind:src="img"/>
                    <h1>{{ title }}</h1>
                    <span>{{ description }}</span>
                </b-card-body>
            </b-card>
            <b-card no-body class="mb-2 blankcard" v-if="blank">
                <b-card-body style="text-align:center;">
                </b-card-body>
            </b-card>
            </a>
        </div>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                required: false
            },
            description: {
                type: String,
                required: false
            },
            img: {
                type: String,
                required: false
            },
            link: {
                type: String,
                required: false
            },
            blank: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    }
</script>
<style>
    .full {
        transition: transform .2s;
    }
    .full:hover {
        transform: scale(1.1);
    }
    .homeitem .card {
        border:none;
        min-height:260px;
    }
    .homeitem .blankcard{
        background-color:#FAFAFA;
    }
    .homeitem h1 {
        margin-top:10px;
        font-size: 1.4rem;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.4;
        letter-spacing: normal;
        text-align: center;
        color: #6CB9D5 !important;
    }
    .homeitem span {
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.19;
        letter-spacing: normal;
        text-align: center;
        color: #707070;
        margin-bottom:8px;
    }
    .homeitem img {
        width: 201px;
        height: 155px;
    }
</style>
